import React from 'react';
import Header from "../thema/tema1/component/Header";
import Footer from "../thema/tema1/component/Footer";
import SideMenu from "../thema/tema1/component/SideMenu";
import PageContext from "../thema/tema1/component/PageContext";
import CustomTable from "../thema/tema1/component/CustomTable";
import CustomModal from "../thema/tema1/component/CustomModal";
import axios from 'axios';
import Properties from "../const/Properties";

const tur = 1;

const active = {kasa: "active"};
const bankalar = {
    0: "BELİRLENMEDİ",
    1: "ZİRAAT",
    2: "İŞ BANKASI"
};

class Kasa extends React.Component {
    componentDidMount() {
    }

    constructor(props) {
        super(props);
        if (localStorage.getItem("token") == "") {
            window.location = '/';
            return false;
        }
        this.state = {
            plaka: "",
            baslangic: "",
            bitis: "",
            firmaId: 0,
            dorsePlaka: "",
            cekiciPlaka: "",
            tarih: "",
            firmalar: [],
            tasimalar: [],
            content: [],
            pageCount: 0,
            tutar: 0,
            bankaId: 0,
            totalRow: 0,
            startRow: 0,
            endRow: 0,
            silId: 0,
            duzenleId: 0,
            kasa: 0,
            ziraat: 0,
            isbankasi: 0,
            makbuzId: 0,
            makbuzDurum: 0,
            silModal: 'none',
            title: ["BANKA", "TUTAR","TARİH", "İŞLEMLER"],
            showDuzenle: false,
            duzenle: false,
            error: 0
        };
        this.handlePageClick({selected:0});
        this.getTotalRow();
        this.kasa();
    }

    onChange = e => {
        this.setState({[e.target.name]: e.target.value})
    }

    onClick = (e) => {
        window.inputmaskReady();
    }
    handlePageClick=e=>{
        this.setState({ startRow: (e.selected*10)+1});
        this.setState({ endRow:((e.selected+1)*10)});
        axios({
            method: 'get',
            url: Properties.baseUrl+'/banka/sayfaliGetir/'+e.selected,
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                var getData = [];
                res.data.forEach(function (eleman) {
                    var elemanIc = new Object;
                    elemanIc.id = eleman.id;
                    elemanIc.bankaId = eleman.bankaId;
                    elemanIc.tutar = eleman.tutar;
                    elemanIc.tarih = eleman.tarih;
                    getData.push(eleman);
                });
                this.setState({firmalar:getData});
                let content = getData.map((item) =>
                    (<tr>
                        <td>{bankalar[item.bankaId]}</td>
                        <td>{item.tutar} €</td>
                        <td>{item.tarih}</td>
                        <td>
                            <div className="row">
                                <div className="col-2">
                                    <button type="button" className="btn btn-block btn-outline-danger"
                                            onClick={e => this.setSil(item)} data-toggle="modal"
                                            data-target="#modal-default">SİL
                                    </button>

                                </div>
                            </div>
                        </td>
                    </tr>));
                this.setState({content: content});
            });
    }
    getTotalRow = ()=>{
        axios({
            method: 'get',
            url: Properties.baseUrl+'/banka/toplam/',
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                this.setState({totalRow:res.data});
                this.setState({pageCount:res.data/10});
            });
    }
    kasa = ()=>{
        axios({
            method: 'get',
            url: Properties.baseUrl+'/banka/kasa/',
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                this.setState({kasa:res.data.kasa});
                this.setState({isbankasi:res.data.isbankasi});
                this.setState({ziraat:res.data.ziraat});
            });
    }
    save = e => {
        let status = true;
        if(status)
        {
            axios({
                method: 'post',
                url:  Properties.baseUrl+'/banka/save',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization" : "Bearer " + localStorage.getItem("token")
                },
                data: {
                    bankaId: this.state.bankaId,
                    tutar: this.state.tutar,
                    tarih: this.state.tarih
                }
            })
                .then(res => {
                    this.getTotalRow();
                    this.handlePageClick({selected:0});
                    window.successful((this.state.showDuzenle?"Transfer Güncellendi.":"Transfer Kaydedildi"));
                    this.setState({bankaId:0});
                    this.setState({tutar:0});
                    this.setState({tarih:""});
                    this.kasa();
                }).catch(res =>{
                window.unsuccessful((this.state.showDuzenle?"Transfer Güncellenemedi.":"Transfer Kaydedilemedi."));
            });
            if(this.state.showDuzenle)
                this.setState({showDuzenle:false});
            this.kasa();
        }
    }
    silModal = ()=>{
        axios({
            method: 'get',
            url: Properties.baseUrl+'/banka/delete/'+this.state.silId,
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                this.getTotalRow();
                this.handlePageClick({selected:0});
                window.successful("Banka Silindi");
                this.setState({bankaId:0});
                this.setState({tutar:0});
                this.setState({tarih:""});
            }).catch(res =>{
            window.unsuccessful("Banka Silinemedi.");
        });
        window.disableModal();
    }
    setSil = (e)=>{
        this.setState({silId:e.id});
    }
    render(props) {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <Header/>
                <SideMenu kasa="active" muhasebe="menu-is-opening menu-open"  muhasebeacik={{display:'Block'}}/>
                <PageContext>
                    <div className="row">
                        <div style={{"width": "99%"}} className="info-box mb-3 col-4">
                            <span className="info-box-icon bg-warning elevation-1"><i
                                className="fas fa-cash-register"></i></span>

                            <div className="info-box-content">
                                <span className="info-box-text">KASA</span>
                                <span className="info-box-number">{this.state.kasa} €</span>
                            </div>
                        </div>
                        <div style={{"width": "99%"}} className="info-box mb-3  col-4">
                            <span className="info-box-icon bg-success elevation-1"><i style={{"color": "#fff"}}
                                                                                      className="fas fa-money-bill"></i></span>

                            <div className="info-box-content">
                                <span className="info-box-text">İŞ BANKASI</span>
                                <span className="info-box-number">{this.state.isbankasi} €</span>
                            </div>
                        </div>
                        <div style={{"width": "99%"}} className="info-box mb-3  col-4">
                            <span className="info-box-icon bg-success elevation-1"><i
                                className="fas fa-money-bill"></i></span>

                            <div className="info-box-content">
                                <span className="info-box-text">ZİRAAT</span>
                                <span className="info-box-number">{this.state.ziraat} €</span>
                            </div>
                        </div>
                    </div>
                    <div className="card card-primary">
                        <div className="card-header">
                            <h3 className="card-title"
                                style={this.state.showDuzenle ? {display: 'none'} : {display: 'block'}}>Ekle</h3>
                        </div>
                        <form>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1">Banka Adı</label>
                                        <label>Banka</label>
                                        <select name="bankaId" className="form-control select2"
                                                onChange={this.onChange} value={this.state.bankaId}>
                                            <option value={0} selected="selected">Banka Seç</option>
                                            <option value={1}>ZİRAAT</option>
                                            <option value={2}>İŞ BANKASI</option>
                                        </select>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1">Tarih</label>
                                        <input onClick={this.onClick} onKeyUp={this.onChange} type="text" name="tarih"
                                               value={this.state.tarih} className="form-control"
                                               data-inputmask-alias="datetime"
                                               data-inputmask-inputformat="dd/mm/yyyy HH:MM" data-mask/>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1">Tutar</label>
                                        <input type="number" value={this.state.tutar} className="form-control"
                                               name="tutar" onChange={this.onChange}
                                               placeholder="Telefon"/>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1"></label>
                                        <button onClick={this.save}
                                                style={this.state.showDuzenle ? {display: 'none'} : {
                                                    margin: "10px",
                                                    display: 'block'
                                                }} type="button" className="btn btn-primary">Ekle
                                        </button>

                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>

                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Transferler</h3>
                        </div>
                        <div className="card-body">
                            <CustomTable state={this.state} getTotalRow={this.getTotalRow}
                                         handlePageClick={this.handlePageClick}></CustomTable>
                        </div>
                    </div>
                </PageContext>
                <Footer/>
                <CustomModal id={"modal-default"} funcModal={this.silModal} title={"Banka Sil"}
                             content={"Transferi Silmek İstediğinizden Emin Misiniz?"}></CustomModal>

            </div>);
    }
}


export default Kasa;
